import React from 'react';
import PropTypes from 'prop-types';
import { UiIcon } from 'ui-components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { changeProfileMenuStep } from 'store';
import { renderNotificationItem } from 'components/socket-notifications/SocketNotifications';

const MobileSizeNotifications = ({ close }) => {
  const { t } = useTranslation();
  const notifications = useSelector(
    (state) => state.notificationReducer.notifications.data
  );
  const dispatch = useDispatch();

  return (
    <>
      <div className='modal-header step-header'>
        <div className='header-info'>
          <UiIcon
            className='mr-0'
            icon='ri-arrow-right-s-line'
            size={20}
            color='#454545'
            onClick={() => dispatch(changeProfileMenuStep('step_1'))}
          />
          <span className='label'>{t('notifications:alerts')}</span>
        </div>
        <UiIcon
          className='header-close'
          icon='ri-close-circle-fill'
          size={20}
          color='#9CAEBB'
          onClick={close}
        />
      </div>

      <div className='modal-body'>
        {notifications?.length < 1 ? (
          <div className='flex center mt-50 mb-30 muted'>
            <UiIcon icon='ri-notification-2-line' className='ml-10' />
            <span>{t('layout:alertsListIsEmpty')}</span>
          </div>
        ) : (
          notifications.map((notification, index) =>
            renderNotificationItem(notification, index)
          )
        )}
      </div>
    </>
  );
};

MobileSizeNotifications.propTypes = {
  close: PropTypes.func,
};

export default MobileSizeNotifications;
